import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { ApiUtils } from '@shared/utils';
import { MiscApi } from '@shared/api/rest';
import type { BankInformationResponse } from '@shared/api/rest/misc';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const getBankInformationEffect = createEffect((params: IQueryParams) => MiscApi.getBankInformation(params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<BankInformationResponse | null>(null)
  .on(getBankInformationEffect.done, (current, data) => data.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getBankInformationEffect.pending, (_, data) => data)
  .on(getBankInformationEffect.fail, () => false)
  .on(getBankInformationEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getBankInformationEffect, () => null)
  .on(getBankInformationEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getBankInformationEffect.done, () => null)
  .reset(clearEvent);

export const $bankInformationStore = {
  events: {
    getBankInformation: ApiUtils.wrapperApi(getBankInformationEffect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
